import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FieldType } from '@ngx-formly/core';
import { debounceTime } from 'rxjs';

@Component({
  selector: 'app-formly-json',
  template: `
    <textarea
      pTextarea
      [rows]="rows"
      [style.min-height]="'calc(' + rows + ' * 1.5em + 1rem)'"
      [formlyAttributes]="field"
      [formControl]="valueFormControl"
      variant="outlined"
      [autoResize]="true"
    ></textarea>
  `,
  styles: [``],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyJsonComponent extends FieldType {
  valueFormControl = new FormControl();

  get rows(): number {
    return this.props.rows ?? 4;
  }

  get control(): FormControl {
    return this.formControl as FormControl;
  }

  get appearance(): 'filled' | 'outlined' {
    return this.props['appearance'] || 'filled';
  }

  constructor() {
    super();
  }

  ngOnInit() {
    this.formControl.valueChanges.subscribe(value => {
      this._setDisplayValue(value);
    });

    this.valueFormControl.valueChanges
      .pipe(debounceTime(100))
      .subscribe(value => {
        this._setControlValue(value);
      });
  }

  private _setControlValue(value: any) {
    if (typeof value === 'string') {
      try {
        this.formControl.setValue(JSON.parse(value));
      } catch (error) {}
    }
  }

  private _setDisplayValue(value: any) {
    if (typeof value !== 'object') {
      return;
    }

    let json = null;
    try {
      json = JSON.stringify(value, null, 2);
    } catch (error) {}

    this.valueFormControl.setValue(json);
  }
}
